// extracted by mini-css-extract-plugin
export default {"tags":"gXnDqJYk9zZLDzDYSOvK","smallTags":"ptDm8wF5tTcOwug1xwDd","tag":"Xucm1_G_S3X6Pdj_1DoG"};